// extracted by mini-css-extract-plugin
export default {"label":"label-ybE7I","firstRow":"firstRow-23R6F","secondRow":"secondRow-K8qkr","userInfoForm":"userInfoForm-y155G","fixedWidth":"fixedWidth-DUYUu"};